import { FormGroup } from '@angular/forms';
import { KeyValueModel } from '@uw/core/models/keyvalue.model';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterList',
    pure: false
})
export class FilterListPipe implements PipeTransform {
  transform(
    value: KeyValueModel[] | null,
    keyFilter: string
  ): KeyValueModel[] | null {
    if (!value) {
      return value;
    }

    if (!keyFilter) {
      return value;
    }

    return value.filter(
      (kv) => kv.key !== keyFilter
    );
  }

}
